<template>
    <div>
        <vue-bottom-sheet-vue2 ref="itemRef"
                               @closed="emitClose"
                               class="dish-details-wrap">
            <div class="dish-details"
                 ref="dishDetails">
                <IconButtonClose class="close_btn"
                                 @click="close" />

                <div v-if="!!computedDish.image"
                     class="dish-details__image">
                    <img :src="computedDish.image"
                         :alt="`Image of ${computedDish.name}`">
                </div>

                <div class="dish-details__wrap"
                     :class="{ 'dish-details__wrap__spacer': !isWMM }">
                    <div class="dish-details__content">
                        <div class="dish-details__content-title">
                            <h3>{{ computedDish.name }}</h3>
                        </div>
                        <p v-if="computedDish.description"
                           class="dish-details__content-text-description"
                           v-html="computedDish.description">
                        </p>
                        <div class="dish-details__content-description">
                            <ul>
                                <li v-if="Boolean(computedDish.is_gluten_free)">
                                    <IconGluttenFreeOutline width="25"
                                                            height="25"
                                                            @click.native.stop="showIconDetails('gluten-free')" />
                                </li>
                                <li v-if="Boolean(computedDish.is_spicy)">
                                    <IconPepperHot width="25"
                                                   height="25"
                                                   @click.native.stop="showIconDetails('chili-pepper')" />
                                </li>
                                <li v-if="Boolean(computedDish.is_vegetarian)">
                                    <IconVegetarian width="25"
                                                    height="25"
                                                    @click.native.stop="showIconDetails('vegeterian')" />
                                </li>
                                <li v-if="Boolean(computedDish.is_low_calorie)">
                                    <IconLowCal width="25"
                                                height="25"
                                                @click.native.stop="showIconDetails('low-calories')" />
                                </li>
                            </ul>
                            <div class="dish-details__content-description__portion">
                                <span v-if="computedDish.weight > 0">{{ computedDish.weight }} g</span>
                                <span v-if="computedDish.volume > 0">{{ computedDish.volume }} ml</span>
                                <span v-if="computedDish.alcohol > 0">{{ computedDish.alcohol }} %</span>
                            </div>
                        </div>
                        <div class="dish-details__content-footer">
                            <span>{{ getFormattedItemPrice(comCalcDishPrice, { isSingle: true, includeSubItems: false })
                            }} </span>
                            <VItemCounter v-if="orderIsAvailable(computedDish)"
                                          :id="computedDish.id"
                                          :value="quantity"
                                          @update:value="updateQuantity" />
                        </div>
                    </div>
                    <template v-if="computedDish.options.length > 0 && !isWMM">
                        <div v-for="selectedOptions, index in selectedOptionsArr"
                             :key="`options-for-${index}`"
                             class="dish-details__options">
                            <h3 v-if="index !== 0"
                                class="dish-details__options__title">
                                {{ `${$t('pages.menu.for')} ` }}
                                <span class="dish-details__options__title__count">{{ index + 1 }}</span>
                                {{ ` ${computedDish.name}:` }}
                            </h3>
                            <DishDetailsOptionsSelect v-for="option in computedDish.options"
                                                      :key="option.id"
                                                      :data="option"
                                                      :radio-name="index"
                                                      :id="'option_' + option.id"
                                                      v-model="selectedOptions[option.id]"
                                                      class="dish-details__options__select" />

                        </div>
                    </template>
                </div>
                <div class="dish-details__order">
                    <VButton v-on:click.native="addToCart"
                             v-if="orderIsAvailable(computedDish)"
                             height="short">
                        {{ $t("Add to cart") }} <span class="dish-details__order__circle"></span> {{
                            getFormattedItemPrice(comCalcDishPrice) }}
                    </VButton>
                </div>

            </div>
        </vue-bottom-sheet-vue2>
        <FoodIconInfoPopup ref="iconDetails"
                           :icon="activeIcon" />
    </div>
</template>

<script>
// import BottomSheet from '@douxcode/vue-spring-bottom-sheet'
// import '@douxcode/vue-spring-bottom-sheet/dist/style.css'
import VueBottomSheetVue2 from "@webzlodimir/vue-bottom-sheet-vue2";
import VItemCounter from "@/components/ui/VItemCounter.vue";
import VButton from "@/components/ui/VButton.vue";
import IconButtonClose from "@/components/icons/IconButtonClose.vue";
import IconGluttenFreeOutline from '@/components/icons/IconGluttenFreeOutline.vue';
import IconPepperHot from '@/components/icons/IconPepperHot.vue';
import IconVegetarian from '@/components/icons/IconVegetarian.vue';
import IconLowCal from '@/components/icons/IconLowCal.vue';
import DishDetailsOptionsSelect from "./components/DishDetailsOptionsSelect.vue";
import FoodIconInfoPopup from "@/components/FoodIconInfoPopup.vue";
import { getFormattedItemPrice } from "@/utils/itemHelper";

export default {
    name: "DishDetails",
    components: {
        VueBottomSheetVue2,
        VButton,
        VItemCounter,
        IconButtonClose,
        IconGluttenFreeOutline,
        IconPepperHot,
        IconVegetarian,
        IconLowCal,
        DishDetailsOptionsSelect,
        FoodIconInfoPopup,
    },
    props: {
        dishId: { type: [String, Number], default: null },
        dish: { type: [Object], default: null }
    },
    emits: ['input'],
    data() {
        return {
            selectedOptionsArr: [],
            quantity: 1,
            toastOptions: {
                position: "top-center",
                timeout: 2000,
                closeOnClick: true
            },
            bottomSheetStyle: {
                '--custom-height': '',
            },
            activeIcon: null,
        };
    },
    mounted() {
        if (this.dish) {
            if (this.dish.subproducts === null || typeof this.dish.subproducts === 'undefined') {
                this.dish.subproducts = [];
            }
        }
        this.selectedOptionsArr.push(this.initSelectedOptions());
        //this.updateHeight();
    },
    updated() {
        //this.updateHeight();
    },
    watch: {
        quantity: {
            handler(newVal) {
                // Disable each order different options select, dublicate options for quantity 
                // const oldVal = this.selectedOptionsArr.length;
                // if (newVal > oldVal) {
                //     for (let i = 0; i < newVal - oldVal; i++) {
                //         this.selectedOptionsArr.push(this.initSelectedOptions());
                //     }
                // } else if (newVal < oldVal) {
                //     this.selectedOptionsArr.splice(newVal);
                // }
                this.dish.count = newVal;
                this.handleUpdateSubproductsPrice();
            },
            immediate: true,
        },
        selectedOptionsArr: {
            handler() {
                this.handleUpdateSubproductsPrice();
            },
            deep: true
        }
    },
    computed: {
        computedDish() {
            return this.dish ? this.dish : this.$store.getters['menuStore/getDish'];
        },
        isFormValid() {
            return this.dish.options.every(option => {
                if (option.is_required) {
                    return this.selectedOptionsArr.every(selectedOptions => {
                        const values = selectedOptions[option.id];
                        if (Array.isArray(values)) {
                            return values.length > 0;
                        }
                        return values !== null && typeof values !== 'undefined';
                    });
                }
                return true;
            });
        },
        comCalcDishPrice() {
            return { ...this.computedDish };
        },
        isWMM() {
            return this.$store.getters['getIsModeWMM'];
        }
    },
    methods: {
        updateHeight() {
            this.$nextTick(() => {
                const content = this.$refs.dishDetails;
                const height = content.scrollHeight;
                this.bottomSheetStyle['--custom-height'] = `${height}px`;
            });
        },
        initSelectedOptions() {
            const res = {};
            this.dish.options.map(option => {
                this.$set(res, option.id, []);
            });
            return res;
        },
        flattenValues(selectedOptions) {
            const flattenedValues = [];
            Object.keys(selectedOptions).forEach((id) => {
                const selectedValues = selectedOptions[id];
                if (Array.isArray(selectedValues)) {
                    selectedValues.forEach((value) => {
                        flattenedValues.push({ ...value, product: { ...value.product, category_id: id } });
                    });
                } else {
                    flattenedValues.push({ ...selectedValues, product: { ...selectedValues.product, category_id: id } });
                }
            });
            return flattenedValues;
        },

        unflattenValues(selectedOptions, flattenedValues) {
            flattenedValues.forEach((item) => {
                const category_id = item.product.category_id;
                selectedOptions[category_id].push(item);
            });
        },
        handleUpdateSubproductsPrice() {
            this.comCalcDishPrice.count = this.quantity;
            if (this.selectedOptionsArr[0]) {
                this.comCalcDishPrice.subproducts = this.flattenValues(this.selectedOptionsArr[0]);
            }
            // for (let i = 0; i < this.quantity; i++) {
            //     this.comCalcDishPrice.subproducts = this.comCalcDishPrice.subproducts.concat(this.flattenValues(this.selectedOptionsArr[i]));
            // }
        },
        updateQuantity(val) {
            this.quantity = val;
        },
        addToCart() {
            if (!this.validateForm()) {
                return;
            }

            // for (let i = 0; i < this.quantity; i++) {
            // }
            const item = { ...this.computedDish };
            item.subproducts = this.flattenValues(this.selectedOptionsArr[0]);
            //item.count = 1;
            item.product = { ...item };

            if (this.isWMM) {
                this.$store.dispatch('cartStore/SET_ITEM_TO_CART', item).then(resp => {
                    if (resp) {
                        this.$toast.success(this.$t('Added to cart'), this.toastOptions);
                    }
                });
            } else {
                this.$store.commit('cartStore/ADD_TO_CART', item);
                this.$toast.success(this.$t('Added to cart'), this.toastOptions);
            }

            this.close();
        },
        orderIsAvailable(computedDish) {
            var locale = this.$store.getters['getCompanyData'].locale;
            // var tableData = this.$store.getters['getTableData'];
            // var table = tableData ? tableData.id : false;
            var available_for_order = computedDish !== null && computedDish.available_for_order;

            return available_for_order
                && (locale.activePaymentCredentials || this.$store.getters['getIsModeHOT'] || this.$store.getters['getIsModeSOT'])
                // && ((locale.pos_terminal_enabled && !locale.posConnection) || locale.posConnection)
                && locale.pos_terminal_enabled
                // && locale.posConnection
                && (this.$store.getters['getCartEnabled']);
            // && table;
        },
        getFormattedItemPrice(item, objParams) {
            return getFormattedItemPrice(item, objParams);
        },
        open() {
            setTimeout(() => this.$refs.itemRef.open(), 10);
        },
        close() {
            this.$refs.itemRef.close();
        },
        emitClose() {     
            setTimeout(() => {
                this.$emit('input', false);
            }, 500);
        },
        showIconDetails(icon) {
            this.activeIcon = icon;
            this.$nextTick(() => {
                this.$refs.iconDetails.open();
            });
        },
        validateForm() {
            return this.dish.options.every(option => {
                if (option.is_required) {
                    const isChecked = this.selectedOptionsArr.every(selectedOptions => {
                        const values = selectedOptions[option.id];
                        if (Array.isArray(values)) {
                            return values.length > 0;
                        }
                        return values !== null && typeof values !== 'undefined';
                    });
                    if (!isChecked) {
                        this.scrollInto('option_' + option.id);
                    }
                    return isChecked;
                }
                return true;
            });
        },
        scrollInto(id) {
            this.$nextTick(() => {
                const element = document.getElementById(id);

                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            });
        },
    }
};
</script>

<style lang="scss" scoped>
@import "/src/scss/assets/variables";

small,
h3,
p,
ul,
li {
    margin: 0;
    padding: 0;
}

ul li {
    list-style: none;
}

.dish-details-wrap {
    &::v-deep .bottom-sheet__card {
        border-radius: 40px 40px 0 0 !important;
        background: $color_alabaster !important;
    }

    ::v-deep .bottom-sheet__draggable-area {
        display: none;
    }

    ::v-deep .bottom-sheet__content {
        max-height: 90vh !important;
        border-radius: 40px 40px 0 0 !important;
    }

    ::v-deep .bottom-sheet__main {

        &::-webkit-scrollbar {
            display: none;
        }
    }
}

.dish-details {

    .close_btn {
        position: absolute;
        right: 16px;
        top: 16px;
        z-index: 10;
        border-radius: 50%;
        background: #c9c9c9;
    }

    &__image {
        position: relative;
        overflow: hidden;
        width: 100%;
        height: 400px;

        border-radius: 40px 40px 0 0;

        &>img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            filter: brightness(80%);
        }
    }

    &__wrap {
        display: grid;
        gap: 12px;

        &__spacer {
            padding-bottom: 75px;

            @media only screen and (max-width: 768px) {
                padding-bottom: 130px;
            }
        }
    }

    &__content {
        padding: 24px;

        display: flex;
        flex-direction: column;
        gap: 10px;

        border-radius: 0 0 20px 20px;

        background-color: white;

        &-title {
            display: flex;
            flex-direction: column;

            &>small,
            h3 {
                font: {
                    size: 22px;
                    weight: 700;
                }

                ;
                line-height: 30px;
                color: $color_black;
                letter-spacing: -0.5px;
            }
        }

        &>p {
            color: $color_dove_gray;

            font: {
                weight: 500;
                size: 16px;
            }

            line-height: 20px;
            letter-spacing: 0.61px;
        }

        &-text-description {
            padding: 8px 0;

            font: {
                weight: 500;
                size: 16px;
            }

            line-height: 20px;
            letter-spacing: 0.61px;
            white-space: pre-line;

            border-width: 1px 0px 1px 0px;
            border-style: solid;
            border-color: #EDEDED;

            color: $color_dove_gray;
        }

        &-description {
            height: 34px;
            display: flex;
            justify-content: space-between;
            align-items: center;

            &>ul {
                display: flex;
                align-items: center;
                gap: 10px;
            }

            &__portion {
                display: flex;
                gap: 12px;

                span {
                    font: {
                        size: 16px;
                        weight: 400;
                    }

                    ;
                    color: $color_dove_gray;
                }
            }
        }

        &-footer {
            display: flex;
            justify-content: space-between;
            align-items: center;

            &>span {
                color: $color_black;

                font: {
                    size: 22px;
                    weight: 700;
                }

                ;
                line-height: 27px;
                letter-spacing: 0.1px;
            }
        }

        .btn {
            margin-top: 30px;
        }

    }

    &__order {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;

        padding: 0 16px 12px;

        background: #FAFAFA;

        &__circle {
            width: 6px;
            height: 6px;
            margin: 0 6px;

            border-radius: 50%;
            display: inline-block;
            vertical-align: middle;

            background-color: white;
        }
    }

    &__options {
        display: grid;
        gap: 12px;

        &__select {
            border: 1px solid #EDEDED;
        }

        &__title {
            padding: 0 24px;

            &__count {
                font-weight: inherit;
                color: $color_violet_electric;
            }
        }
    }


}
</style>
